import { gql } from '@apollo/client';
import KEYBOARDING_ENRICHMENT_SETTING from '../../fragments/keyboarding-enrichments-setting';

const UPDATE_KEY_CLASSROOM_ENRICHMENT_SETTING_MUTATION = gql`
  mutation updateKeyClassroomSettingEnrichmentActivities(
    $data: UpdateKeyClassroomSettingEnrichmentInput!
  ) {
    updateKeyClassroomSettingEnrichmentActivities(data: $data) {
      ...BaseKeyEnrichmentActivitySettings
    }
  }
  ${KEYBOARDING_ENRICHMENT_SETTING}
`;

export default UPDATE_KEY_CLASSROOM_ENRICHMENT_SETTING_MUTATION;
